import { MediaPreviewDialog } from '@/shared/ui/media-preview-dialog'
import { PageContainer } from '@/shared/ui/page-container'
import { DetailsCard } from './details-card'
import { FormHeader } from './form-header'
import { MapCard } from './map-card'
import { TranslationsCard } from './translations-card'
import { useDestinationForm } from './use-destination-form'

/** Create / edit (or read-only detail) page of a destination. Rendering only — state and save flows live in `useDestinationForm`. */
export function DestinationFormPage() {
  const {
    isEdit,
    isReadonly,
    listPath,
    isLoadingDestination,
    isLoadingLanguages,
    supportedLanguages,
    countries,
    provinces,
    state,
    media,
    actions,
    isSaving,
    unsavedChangesDialog,
  } = useDestinationForm()
  const isBusy = actions.savingSection !== null

  return (
    <PageContainer>
      <FormHeader
        isEdit={isEdit}
        isReadonly={isReadonly}
        listPath={listPath}
        isSaving={isSaving}
        onBack={actions.navigateToList}
        onSubmit={() => void actions.handleSubmit()}
      />
      <div className="space-y-6">
        <TranslationsCard
          isEdit={isEdit}
          isReadonly={isReadonly}
          isLoading={isLoadingDestination || isLoadingLanguages}
          languages={supportedLanguages}
          translations={state.translations}
          onChange={state.setTranslations}
          entityId={state.translationEntityId}
          runningJobCount={state.runningJobCount}
          isSaving={actions.savingSection === 'translations'}
          isSaveDisabled={isBusy}
          onSave={() => void actions.handleSaveTranslations()}
        />
        <DetailsCard
          isEdit={isEdit}
          isReadonly={isReadonly}
          isLoading={isLoadingDestination}
          form={state.form}
          onChange={state.setForm}
          countries={countries}
          provinces={provinces}
          onPreview={media.setMediaPreviewUrl}
          onBannerUploadingChange={media.setIsBannerUploading}
          onThumbnailUploadingChange={media.setIsThumbnailUploading}
          isSaving={actions.savingSection === 'details'}
          isSaveDisabled={isBusy}
          onSave={() => void actions.handleSaveDetails()}
        />
        <MapCard
          isEdit={isEdit}
          isReadonly={isReadonly}
          isLoading={isLoadingDestination}
          areaBoundary={state.form.areaBoundary}
          centerPoint={state.form.centerPoint}
          onAreaBoundaryChange={state.setAreaBoundary}
          onCenterPointChange={state.setCenterPoint}
          onSaveMap={(boundary, center) => void actions.handleSaveMap(boundary, center)}
          isSaving={actions.savingSection === 'map'}
        />
      </div>
      <MediaPreviewDialog
        url={media.mediaPreviewUrl}
        onClose={() => media.setMediaPreviewUrl(null)}
      />
      {unsavedChangesDialog}
    </PageContainer>
  )
}
